<template>
  <transition name="fade">
    <component :is="currentComponent" />
  </transition>
</template>

<script>
import Solutions from '@/views/Solutions.vue';
import ProjectDetails from '@/views/ProjectDetails.vue';
import GptDocumentsView from '@/views/GptDocumentsView.vue';

export default {
  data() {
    return {
      currentComponent: this.decideComponent(),
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        this.currentComponent = this.decideComponent();
      }
    }
  },
  methods: {
    decideComponent() {
      const { pid, datasetId, ptab ,stype } = this.$route.query;

      if (pid && datasetId && ptab === 'mairaDatasets') {
        return GptDocumentsView;
      } else if (pid) {
        return ProjectDetails;
      } else if (stype) {
        return Solutions;
      }
      else {
        this.$router.push({
          path: `/404`,
        });
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
